import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {
  Breadcrumbs,
  Button,
  FormControl,
  Grid,
  InputLabel,
  Link,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import Appbar from "../../components/Appbar";
import Body from "../../layout/Body";
import TotalPublisher from "./TotalPublisher";
import TotalUser from "./totalUser";
import TotalSurveryAttempt from "./TotalSurveryAttempt";
import PartnerTotalRevenue from "./PartnerTotalRevenue";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";
import { totalUsersAction } from "../../redux/toolkit/dashbaord/totalUsers";
import { toPublisherAction } from "../../redux/toolkit/dashbaord/toPublisher";
import { totalSurveyAttemptAction } from "../../redux/toolkit/dashbaord/totalSurveyAttempt";
import { partnerTotalRevenueAction } from "../../redux/toolkit/dashbaord/partnerTotalRevenue";
import { dateFormatStartFun } from "../../helper/dateConverter";
import { useDispatch, useSelector } from "react-redux";
import { getPublisherAction } from "../../redux/toolkit/publisher/getPublisher";
import TotalSurveyCompleted from "../InAdminPublisherDashboard/TotalSurveyCompleted";
import TotalConversionRate from "../InAdminPublisherDashboard/TotalConversionRate";
import DailyActiveUser from "./dailyActiveUser";

let breadcrumb = (
  <Stack>
    <Breadcrumbs
      separator={
        <NavigateNextIcon sx={{ color: "#5E6C8A" }} fontSize="small" />
      }
      aria-label="breadcrumb"
    >
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/"
      >
        Home
      </Link>
    </Breadcrumbs>
    <Typography sx={{ color: "#5E6C8A" }} variant="h5">
      Home
    </Typography>
  </Stack>
);

export default function Home() {
  const dispatch = useDispatch();

  const [date, setDate] = useState({
    startDate: null,
    endDate: null,
  });
    const [publisher, setPublisher] = useState(null);
    console.log("publisher=======>",publisher)
  

  //  const getPublisherSelector = useSelector((state) => state.getPublisher);
  //   const { data: publiserData } = getPublisherSelector;

  const dateWiseUser = () => {

    dispatch(
      totalUsersAction({
        startDate: dateFormatStartFun(date?.startDate),
        endDate: dateFormatStartFun(date?.endDate),
      })
    );
    dispatch(
      toPublisherAction({
        startDate: dateFormatStartFun(date?.startDate),
        endDate: dateFormatStartFun(date?.endDate),
        // publisherId: publisher
      })
    );
    dispatch(
      totalSurveyAttemptAction({
        startDate: dateFormatStartFun(date?.startDate),
        endDate: dateFormatStartFun(date?.endDate),
        // publisherId: publisher
      })
    );
    dispatch(
      partnerTotalRevenueAction({
        startDate: dateFormatStartFun(date?.startDate),
        endDate: dateFormatStartFun(date?.endDate),
      })
    );
  };

  useEffect(() => {
    dispatch(getPublisherAction({}));
  }, []);

  return (
    <>
      <Helmet>
        <title>Real Opinion Admin | home</title>
      </Helmet>

      <Appbar breadcrumb={breadcrumb} />
      <Body>
        <Stack direction="row" spacing={2}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Min Data"
              value={date?.startDate}
              maxDate={moment()}
              onChange={(newValue) => {
                setDate({ ...date, startDate: newValue });
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Max Data"
              value={date?.endDate}
              minDate={date?.startDate}
              maxDate={moment()}
              onChange={(newValue) => {
                setDate({ ...date, endDate: newValue });
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>

        

          {date?.startDate && date?.endDate && (
            <Button variant="contained" onClick={dateWiseUser}>
              Submit
            </Button>
          )}
        </Stack>

        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid xs={4} item>
            <TotalUser />
          </Grid>

          <Grid xs={4} item>
            <TotalPublisher />
          </Grid>

          <Grid xs={4} item>
            <TotalSurveryAttempt />
          </Grid>

          <Grid xs={4} item>
            <PartnerTotalRevenue />
          </Grid>

          <Grid xs={4} item>
            <DailyActiveUser />
          </Grid>
        </Grid>
      </Body>
    </>
  );
}
